import { Component, Inject } from '@angular/core';
import _ from 'lodash';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { FormBuilder } from '@angular/forms';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiQuery } from '../../../web-services/api/api.query';
import { UtilService } from '../../../services/util.service';
import { ApiStore } from '../../../web-services/api/api.store';
import { ApiService } from '../../../web-services/api/api.service';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { CommonModule } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import moment from 'moment';

@Component({
  selector: 'app-view-ticket-modal',
  standalone: true,
  imports: [TranslateModule,RTLDivDirectiveDirective,CommonModule,NgbTooltipModule],
  templateUrl: './view-ticket-modal.component.html',
  styleUrl: './view-ticket-modal.component.scss'
})
export class ViewTicketModalComponent {
  currentLang;
	translationsObj;
  isMobile: Boolean;
	usageType = 1;
  binName;
  binAddress;
  description;
  binNeighborhood;
  resolvedDescription;
  installedBinName;
  bin_location;
  is_installed;
  is_false_ticket;
  is_replaced;
  is_removed_from_site;
  is_removed_from_bin;
  reasonOfReplacementID;
  reasonOfReplacementEn;
  reasonOfReplacementHe;
  analysisNameEn;
  analysisNameHe;
  collection_mode;
  partialEdit : boolean = false;
  user_role_id = 0;
	selectedBinInfo: any = null;
	private readonly destroy$ = new Subject<void>();
	gpsRequested: boolean = false;
	gpsLocationHistory: any[] = [];
	displayGpsApproval: boolean = false;

  constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private fb: FormBuilder,@Inject(MAT_DIALOG_DATA) public data: any,
  private apiQuery:ApiQuery,private dialogRef: MatDialogRef<ViewTicketModalComponent>,private modalService: NgbModal,private apiService:ApiService,private apiStore:ApiStore,
  public utilService: UtilService) {
    this.dialogRef.disableClose = true;
    this.translator.currentLangEmitter$
		.subscribe(async value=>{						
		  this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
		  this.currentLang = value;	
		})
   }

  ngOnInit() {
    this.onResize();
	  this.responsiveService.checkWidth();

    this.apiQuery.user$.subscribe(user => {
			if (!user) {
				return;
			}		
			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}	
      if ((user["user_role_id"] == 3) || (user["user_role_id"] == 4)) {
        this.partialEdit = true;
      }else{
        this.partialEdit = false;
      }
      this.user_role_id = user["user_role_id"];
		});
    if(this.data.chosenTicket.ticket_event_type_id == 1 || this.data.chosenTicket.ticket_event_type_id == 4){
      this.analysisNameEn = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].analysis_name;
      this.analysisNameHe = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].analysis_name_hebrew;
      this.reasonOfReplacementID = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].ticket_remove_replace_cause_name ? _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].ticket_remove_replace_cause_name : _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].replace_cause_id;
      this.reasonOfReplacementEn = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].ticket_remove_replace_cause_name ? _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].ticket_remove_replace_cause_name : _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].replace_cause_name;
      this.reasonOfReplacementHe = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].ticket_remove_replace_cause_name_hebrew ? _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].ticket_remove_replace_cause_name_hebrew : _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].replace_cause_name_hebrew;
      this.is_replaced = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].is_replaced;
      this.is_removed_from_bin = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].is_removed_from_bin;
      this.is_removed_from_site = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].is_removed_from_site;
      this.binName = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][0].bin_name;
      this.binAddress = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][0].bin_address;
      this.description = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["1"][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["1"].length - 1].comment;
      this.collection_mode = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["1"][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["1"].length - 1].collection_mode;
      if(this.data.chosenTicket.ticket_event_type_id == 4){
        this.is_false_ticket = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].rm_is_false_ticket_event;
      }
    }else if(this.data.chosenTicket.ticket_event_type_id == 3){
      this.is_installed = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][0].is_installed;
      this.bin_location = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][0].installed_lat + "," + _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["1"][0].installed_lon;
      this.binAddress = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][0].installed_bin_address;
      this.installedBinName = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status] ? _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].installed_bin_name : '';
      this.description = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["1"][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["1"].length - 1].comment;
      this.binNeighborhood = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].installed_bin_neighborhood ? _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].installed_bin_neighborhood : '';
      this.is_false_ticket = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")[this.data.chosenTicket.status].length - 1].installed_is_false_ticket_event;
    }    
    this.resolvedDescription = _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["4"] ? _.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["4"][_.groupBy(this.data.chosenTicket["ticketInfo"], "status_id")["4"].length - 1].comment : '';

    this.apiService.getBinInfo(this.data.chosenTicket.bin_id);
    this.apiQuery.binInfo$.pipe(takeUntil(this.destroy$)).subscribe((info) => {
			this.selectedBinInfo = info;			

			this.gpsLocationHistory = [];
			this.displayGpsApproval = false;
			
			if(info){
				const dataToSend = {
					"bin_id" : this.selectedBinInfo.bin_id
				};
				this.apiService.getBinGpsLocationHistory(dataToSend).pipe(takeUntil(this.destroy$)).subscribe((response:any) => {
					if(response.GpsHistoryObj == null){
						this.gpsRequested = false;
					}else if(response.GpsHistoryObj?.length > 0){
						this.gpsLocationHistory = response.GpsHistoryObj;
						//get the last item in the array
						const lastItem = this.gpsLocationHistory[this.gpsLocationHistory.length - 1];
						if(lastItem.request_status == 1 || lastItem.request_status == 2){
							this.gpsRequested = true;
						}else if(lastItem.request_status == 3){
							const sameCoords =
								lastItem.bin_lat == this.selectedBinInfo['Bin_location'].bin_latitude &&
								lastItem.bin_lon == this.selectedBinInfo['Bin_location'].bin_longitude;
								if(sameCoords){
									this.gpsRequested = false;
								}else{
									this.gpsRequested = true;
								}
						}else if(lastItem.request_status == 4 || lastItem.request_status == 5){
							this.gpsRequested = false;
						}
						this.displayGpsApproval = this.shouldDisplayGpsApproval(this.gpsLocationHistory);
					}
				});				
			}
		});
  }

  requestGpsSync(){
    if(this.gpsRequested){
      return;
    }
    this.gpsRequested = true;
    const dataToSend = {
      "is_gps_enabled" : "1",
      "bin_id_list" : [[Number(this.selectedBinInfo.bin_id),Number(this.selectedBinInfo.cluster_id)]]			
    };
    this.apiService.setBinThresholdsAndRestrictions(dataToSend).pipe(takeUntil(this.destroy$)).subscribe((v:any) => {
      this.apiService.getBinInfo(this.selectedBinInfo.bin_id);
      this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
      this.apiStore.update({ allFilteredBasicBins: [] });                    
      this.apiStore.update({ filteredBasicBins: [] }); 
      this.apiService.getfilteredBasicBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
    });
  }
  
	shouldDisplayGpsApproval(responseItems) {
		const lastStatus3Index = [...responseItems]
		  .map(item => item.request_status)
		  .lastIndexOf(3);

		if (lastStatus3Index === -1) {
		  return false;
		}

		const lastStatus3Item = responseItems[lastStatus3Index];

		// Same coordinates as selected bin → do not display
		const sameCoords =
		  lastStatus3Item.bin_lat == this.selectedBinInfo['Bin_location'].bin_latitude &&
		  lastStatus3Item.bin_lon == this.selectedBinInfo['Bin_location'].bin_longitude;
	  
		if (sameCoords) {
		  return false;
		}
	  
		// If the item still has status 3, it hasn't been approved/rejected yet
		// The same object changes request_status to 4/5 when approve/reject
		return lastStatus3Item.request_status == 3;
	}
  
  onResize() {
    this.responsiveService.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  get safePicUrl(): string | null {
    const raw = this.data?.chosenTicket?.pic_url;
    if (!raw || typeof raw !== 'string') return null;
    // s3://bucket/key  ->  https://bucket.s3.amazonaws.com/key
    const match = /^s3:\/\/([^/]+)\/(.+)$/.exec(raw);
    if (match) {
      const [, bucket, key] = match;
      return `https://${bucket}.s3.amazonaws.com/${key}`;
    }
    if (/^https?:\/\//i.test(raw)) return raw;
    return null;
  }

  closeModal(){
    this.dialogRef.close();
  }
}
